"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OembedErrorFromJSON = OembedErrorFromJSON;
exports.OembedErrorFromJSONTyped = OembedErrorFromJSONTyped;
exports.OembedErrorToJSON = OembedErrorToJSON;
exports.OembedErrorToJSONTyped = OembedErrorToJSONTyped;
function OembedErrorFromJSON(json) {
    return OembedErrorFromJSONTyped(json, false);
}
function OembedErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': json['status'],
        'message': json['message'],
    };
}
function OembedErrorToJSON(value) {
    return OembedErrorToJSONTyped(value, false);
}
function OembedErrorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'message': value.message,
    };
}
